import {
	AddNewWorkspaceConnectionsViewProps,
	WorkspaceConnectedItemTypeConfiguration,
} from "src/components/views/workspaces/workspaceConnections/connectionTypes/WorkspaceConnectedItemTypeConfiguration.ts";
import i18n from "i18next";
import { faCogs } from "@fortawesome/pro-regular-svg-icons";
import { ConnectProductChangesToWorkspaceDataGrid } from "src/components/views/workspaces/workspaceConnections/connectionTypes/productChange/ConnectProductChangesToWorkspaceDataGrid.tsx";
import { ProductChangeDialog } from "src/components/views/erp/productChanges/changes/ProductChangeDialog.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const workspaceProductChangeConnectionsConfiguration: WorkspaceConnectedItemTypeConfiguration = {
	typeLabel: i18n.t("product_change"),
	icon: faCogs,
	isEnabled: () => true,
	addNewConnectionsView: (props: AddNewWorkspaceConnectionsViewProps) => (
		<ConnectProductChangesToWorkspaceDataGrid {...props} />
	),
	openItemDialog: ({ itemId, openDialog }) => {
		openDialog(({ onContentEdited }) => ({
			title: i18n.t("product_change"),
			size: "lg",
			agentContext: {
				key: defineAgentUiContextKey("workspaces.productChange.dialog"),
				title: i18n.t("product_change"),
				data: {
					productChangeId: itemId,
				},
			},
			content: (
				<ProductChangeDialog
					productChangeId={itemId}
					onFormEdited={onContentEdited}
					onCompleted={async () => {}}
				/>
			),
		}));
	},
};
